import React, { useState, useEffect } from 'react'; 
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import { Modal, Button } from 'react-bootstrap';
import axios from 'Uitilities/axios';
import { useSearchParams, useNavigate } from 'react-router-dom';

const AnalyzeListSearch = ({ setsearchCondition, mapShow, ToggleMapSideBar }) => {
  const [condition, setCondition] = useState("AND");
  const [testOptions, setTestOptions] = useState([]);
  const [type, setType] = useState({});
  const [limit, setLimit] = useState({});
  const [show, setShow] = useState(false);
  const [selectTest, setSelectTest] = useState("default");
  const [TempsearchCondition, setTempsearchCondition] = useState([]);
  const [value, setValue] = useState("");
  const [selectLimit, setSelectLimit] = useState("default");
  const [selectedConditionKey, setSelectedConditionKey] = useState(""); 
  const [frequency, setFrequency] = useState(""); 
  const [frequency1, setFrequency1] = useState(""); // 新增頻率 1 狀態
  const [frequency2, setFrequency2] = useState(""); // 新增頻率 2 狀態
  const [applyPreviousTest, setApplyPreviousTest] = useState(false); 
  const [searchParams] = useSearchParams();
  const navigate = useNavigate(); 

  useEffect(() => {
    const initialConditions = [];
    let index = 0;

    while (searchParams.get(`colName${index}`)) {
      const filter = searchParams.get(`filter${index}`);
      const colName = searchParams.get(`colName${index}`);
      const limit = searchParams.get(`limit${index}`);
      const value = searchParams.get(`value${index}`);
      const testCode = searchParams.get(`testCode${index}`);
      const frequency = searchParams.get(`frequency${index}`);
      const frequency1 = searchParams.get(`frequency1${index}`);
      const frequency2 = searchParams.get(`frequency2${index}`);


      initialConditions.push({
        filter,
        index,
        key: colName,
        colName,
        limit,
        value,
        testCode,
        frequency: frequency || null,
        frequency1: frequency1 || null,
        frequency2: frequency2 || null,

      });

      index++;
    }

    if (initialConditions.length > 0) {
      setTempsearchCondition(initialConditions);
      setsearchCondition(initialConditions);
    }
  }, [searchParams, setsearchCondition]);

  const Search = () => {
    let postData = [...TempsearchCondition];
    setsearchCondition(postData);

    const params = new URLSearchParams();
    const testType = searchParams.get('testType') || 'A';
    params.append('testType', testType);
    
    postData.forEach((condition, index) => {
      params.append(`colName${index}`, condition.colName);
      params.append(`filter${index}`, condition.filter);
      params.append(`frequency${index}`, condition.frequency || '');
      params.append(`frequency1${index}`, condition.frequency1 || '');
      params.append(`frequency2${index}`, condition.frequency2 || '');
      params.append(`key${index}`, condition.key);
      params.append(`limit${index}`, condition.limit);
      params.append(`testCode${index}`, condition.testCode);
      params.append(`value${index}`, condition.value);
    });

    params.append('activeTab', 'inspect');
    params.append('inspectStatistic', 'finish');
    params.append('inspectRecord', '2024');

    navigate(`?${params.toString()}`);
  };

  const Clear = () => {
    setsearchCondition([]);
    setTempsearchCondition([]);
    setFrequency("");
    setFrequency1("");
    setFrequency2("");
    setApplyPreviousTest(false);
    navigate(`/TYBridge2/Workinformation/BridgeSearch`);
  };

  const handleCondition = (e) => {
    setCondition(e.target.id);
  };

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const getTestOptions = () => {
    axios.get(`https://tybms.tycg.gov.tw/newApi/BridgeTest/GetAnalyzeCodeList`)
      .then(res => {
        console.log("取得測試選項成功:", res.data);
        setTestOptions(res.data);
      })
      .catch(err => {
        console.error("取得測試選項失敗:", err);
        alert(err);
      });
  };

  const getConditionList = () => {
    axios.get(`https://tybms.tycg.gov.tw/newApi/BridgeTest/BridgeTestSearchOptions`)
      .then(res => {
        console.log("取得條件列表成功:", res.data);
        setType(res.data);
      })
      .catch(err => {
        console.error("取得條件列表失敗:", err);
        alert(err);
      });
  };

  const getDbLimit = () => {
    axios.get(`NcuInventory/DbLimitOptions`)
      .then(res => {
        console.log("取得限制選項成功:", res.data);
        setLimit(res.data);
      })
      .catch(err => {
        console.error("取得限制選項失敗:", err);
        alert(err);
      });
  };

  const handleTestChange = (e) => {
    const selectedTestCode = e.target.value;
    setSelectTest(selectedTestCode);
    console.log('selectTest changed to:', selectedTestCode);

    let selectedKey = "";
    switch (selectedTestCode) {
      case 'RHM':
        selectedKey = "build_year";
        break;
      case 'TCIC':
      case 'ACT':
      case 'CSDCC':
      case 'CR':
        selectedKey = "U";
        break;
      case 'MCT':
        selectedKey = "corrosion_fe";
        break;
      default:
        selectedKey = "";
    }
    setSelectedConditionKey(selectedKey);
  };

  const SetCondition = () => {
    if (selectedConditionKey) {
      let updatedCondition;

      if (['TCIC', 'ACT', 'CSDCC', 'CR'].includes(selectTest) && applyPreviousTest) {
        // 鎖定 colName 為 "U值"，limit 為 "大於"，value 為 "3"
        updatedCondition = {
          filter: condition,
          index: TempsearchCondition.length,
          key: "U值",
          colName: "U值",
          limit: "大於",
          value: "3",
          testCode: selectTest,
          frequency1: frequency1 ? `${frequency1}` : null,
          frequency2: frequency2 ? `${frequency2}` : null,
        };
      } else if (selectTest === 'MCT' && applyPreviousTest) {
        updatedCondition = {
          filter: condition,
          index: TempsearchCondition.length,
          key: "碳鋼腐蝕等級",
          colName: "碳鋼腐蝕等級",
          limit: "等於",
          value: "CX",
          testCode: selectTest,
          frequency1: frequency1 ? `${frequency1}` : null,
          frequency2: frequency2 ? `${frequency2}` : null,
        };
      } else {
        const colName = type[selectedConditionKey];
        updatedCondition = {
          filter: condition,
          index: TempsearchCondition.length,
          key: selectedConditionKey,
          colName: colName,
          limit: selectLimit,
          value: value,
          testCode: selectTest,
          frequency: applyPreviousTest && frequency ? `${frequency}` : null,
        };
      }

      setTempsearchCondition([...TempsearchCondition, updatedCondition]);
    }
  };

  useEffect(() => {
    getTestOptions();
    getConditionList();
    getDbLimit();
  }, []);   
    
  return (
    <>
      <div className="text-left d-flex">
        <h5>橋梁詳檢因子篩選查詢</h5>
        {/* <div className="o-box__btn showmap-btn">
          <div className="o-btn-orientation--hori">
            {mapShow ?
              <div className="o-btn-group">
                <button className="o-btn o-btn--text js-left-box__shrimp" onClick={ToggleMapSideBar}>
                  <i className="o-btn__icon icon-right-dir"></i>
                  不顯示地圖
                </button>
              </div>
              :
              <div className="o-btn-group">
                <button className="o-btn o-btn--text js-left-box__hide" onClick={ToggleMapSideBar}>
                  <i className="o-btn__icon icon-left-dir"></i>
                  顯示地圖
                </button>
              </div>
            }
          </div>
        </div> */}
      </div>
      <div className="row">
        <div className="col-12">
          <div className="search_section">
            <div className="d-flex condition-bar">
              <h6>條件類型</h6>
              <Button variant="primary" onClick={handleShow}>
                新增條件
              </Button>
              <h6>(預設為搜尋所有橋，若只有一個條件，請選擇"且")</h6>
            </div>
            <Modal size="xl" aria-labelledby="contained-modal-title-vcenter" centered show={show} onHide={handleClose} animation={false}>
              <Modal.Header closeButton>
                <Modal.Title>新增條件</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div className="addCondition_modal">
                  <div className="d-flex condition-bar justify-content-between">
                    <h6>橋梁詳檢因子</h6>
                    <div className="btn-group btn-group-sm OrAndBtn" role="group" aria-label="Basic radio toggle button group" onClick={handleCondition}>
                      <input type="radio" className="btn-check" name="btnradio" id="btnradio2" autoComplete="off" value="AND" checked={condition === "AND"} onChange={handleCondition} />
                      <label className="btn btn-outline-secondary" btnradio2="btnradio2" id='AND'>且</label>
                      <input type="radio" className="btn-check" name="btnradio" id="btnradio1" autoComplete="off" value="OR" checked={condition === "OR"} onChange={handleCondition} />
                      <label className="btn btn-outline-secondary" btnradio1="btnradio1" id='OR'>或</label>
                    </div>
                    <select 
                      className="form-select form-select-sm " 
                      style={{ width: '20%' }} 
                      value={selectTest} 
                      onChange={handleTestChange}
                    >
                      <option value="default" disabled>橋梁詳檢因子</option>  
                      {testOptions.map(option => (
                        <option key={option.id} value={option.testCode}>{option.testName}</option>
                      ))}
                    </select>
                    <input 
                       type="text" 
                   className="form-control form-control-sm" 
                    value={type[selectedConditionKey] ? type[selectedConditionKey] : ''} 
                 readOnly 
                  style={{ width: '20%' }} 
                     />
                    <select 
                      className="form-select form-select-sm" 
                      style={{ width: '20%' }} 
                      value={selectLimit} 
                      onChange={(e) => { setSelectLimit(e.target.value) }}
                      disabled={['TCIC', 'ACT', 'CSDCC', 'CR'].includes(selectTest) && applyPreviousTest}
                    >
                      <option value="default" disabled={true}>符號</option>
                      {Object.values(limit).map((limitOption, index) => (
                        <option key={index} value={limitOption}>{limitOption}</option>
                      ))}
                    </select>
                    {selectTest === 'MCT' ? (
                      <select 
                        className="form-select form-select-sm" 
                        style={{ width: '20%' }} 
                        value={value} 
                        onChange={(e) => { setValue(e.target.value) }}
                      >
                        <option value="default" disabled>選擇腐蝕等級</option>
                        {["CX", "C5", "C4", "C3", "C2", "C1"].map((option, index) => (
                          <option key={index} value={option}>{option}</option>
                        ))}
                      </select>
                    ) : (
                      <input 
                      type="text" 
                      className="form-control form-control-sm" 
                      placeholder="請輸入數值" 
                      value={value} 
                      onChange={(e) => { setValue(e.target.value) }} 
                      style={{ width: '20%' }} 
                      disabled={['TCIC', 'ACT', 'CSDCC', 'CR'].includes(selectTest) && applyPreviousTest}
                      />
                    )}
                  </div>
                  <div className="d-flex justify-content-end mt-3 align-items-center">
                    <input 
                      type="checkbox" 
                      checked={applyPreviousTest} 
                      onChange={(e) => setApplyPreviousTest(e.target.checked)} 
                      className="me-2"
                    />
                    <h6 className="me-2">套用上次試驗紀錄</h6>
                    {['TCIC', 'ACT', 'CSDCC', 'CR'].includes(selectTest) && applyPreviousTest ? (
                      <div className='input_value d-flex align-items-center'>
                        <span>U &gt;= 3 時</span>
                        <input 
                          type="text" 
                          placeholder="請輸入數字"
                          value={frequency1} 
                          onChange={(e) => { setFrequency1(e.target.value) }} 
                          style={{ width: '100px', marginLeft: '10px', marginRight: '10px' }} 
                        />
                        <span>年一次</span>

                        <span style={{ marginLeft: '20px' }}>U &lt; 3 時</span>
                        <input 
                          type="text" 
                          placeholder="請輸入數字"
                          value={frequency2} 
                          onChange={(e) => { setFrequency2(e.target.value) }} 
                          style={{ width: '100px', marginLeft: '10px', marginRight: '10px' }} 
                        />
                        <span>年一次</span>
                      </div>
                    ) : selectTest === 'MCT' && applyPreviousTest ? (
                      <div className='input_value d-flex align-items-center'>
                        <span>達 CX 時</span>
                        <input 
                          type="text" 
                          placeholder="請輸入數字"
                          value={frequency1} 
                          onChange={(e) => { setFrequency1(e.target.value) }} 
                          style={{ width: '100px', marginLeft: '10px', marginRight: '10px' }} 
                        />
                        <span>年一次</span>

                        <span style={{ marginLeft: '20px' }}>未達 CX 時</span>
                        <input 
                          type="text" 
                          placeholder="請輸入數字"
                          value={frequency2} 
                          onChange={(e) => { setFrequency2(e.target.value) }} 
                          style={{ width: '100px', marginLeft: '10px', marginRight: '10px' }} 
                        />
                        <span>年一次</span>
                      </div>
                    ) : (
                      <div className='input_value d-flex align-items-center'>
                        <input 
                          type="text" 
                          placeholder="請輸入數字"
                          value={frequency} 
                          onChange={(e) => { setFrequency(e.target.value) }} 
                          disabled={!applyPreviousTest}
                          style={{ width: '100px', marginLeft: '10px', marginRight: '10px' }} 
                        />
                        <span>年一次</span>
                      </div>
                    )}
                  </div>
                  <button type="button" className="btn btn-primary mt-3" data-toggle="modal" data-target="#exampleModal" onClick={SetCondition}>新增篩選</button>
                </div>
              </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                  關閉
                </Button>
                <Button variant="primary" onClick={handleClose}>
                  確認
                </Button>
              </Modal.Footer>
            </Modal>
            <div className="condition-list">
              {TempsearchCondition.map(item => (
                <div className="condition-item" key={item.index} id={item.index}>
                  <button type="button" className="del-condition" id={item.index} onClick={() => setTempsearchCondition(TempsearchCondition.filter(cond => cond.index !== item.index))}>
                    <span>&times;</span>
                  </button>
                  <span>{item.filter === "AND" ? "且" : "或"}</span>
                  <span>{item.colName}</span>
                  <span>{item.limit}</span>
                  <span>{item.value}</span>                  
                  {item.testCode === 'MCT' && item.frequency1 && item.frequency2 ? (
                    <>
                      <span>，碳鋼腐蝕等級 = CX 時檢測頻率: {item.frequency1}年一次</span>
                      <span>，碳鋼腐蝕等級 &lt; CX 時檢測頻率: {item.frequency2}年一次</span>
                    </>
                  ) : item.frequency1 && item.frequency2 && (
                    <>
                      <span>，U &gt;= 3 時檢測頻率: {item.frequency1}年一次</span>
                      <span>，U &lt; 3 時檢測頻率: {item.frequency2}年一次</span>
                    </>
                  )}
                </div>
              ))}
            </div>
            <div className="condition-btn d-flex">
              <button className="btn btn-primary" onClick={Search}>開始篩選</button>
              <button className="btn btn-danger" onClick={Clear}>清除篩選</button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AnalyzeListSearch;